<template>
    <div id="collegeDetail">
        <div class="college_info  w-100 margin-top">
            <div  v-show="professionalDetail!==''&&!loadingDetail"  class="padding-x-y">
                <div class="titltTop">
                    <div>
                        <div class="logo">
                            <span class="font-weight-bolder">
                                {{professionalDetail.majorName}}
                            </span>
                            <span v-if="professionalDetail.monthlySalary!==null" class=" xc">
                                毕业5年薪酬：<span class="yellow salary">{{professionalDetail.monthlySalary}}</span>
                            </span>
                        </div>
                    </div>
                </div>
                <div class="margin-top delFloat">
                    <div class="float-left yellow margin-right">{{professionalDetail.majorName+'( '+professionalDetail.levelName+')'}}</div>
                    <div class="float-left margin-right">所属学科：<span class="yellow">{{professionalDetail.className}}</span></div>
                    <div class="float-left margin-right">所属门类：<span class="yellow">{{professionalDetail.categoryName}}</span></div>
                    <div class="float-left">专业代码：<span class="yellow">{{professionalDetail.majorCode}}</span></div>
                </div>
            </div>
            <loading  :show="loadingDetail"></loading>
        </div>
        <div class="text-center menuStyle" :class="gudMenu?'gud':''">
            <span :key="index" v-for="(item,index) in getLeftDirectoryList">
                <span class="margin-right cursorSz"  @click="selectDirectory(item.name)">
                    {{item.name}}
                </span>
                <span class="margin-right"
                      v-show="index<getLeftDirectoryList.length-1">|</span>
            </span>
        </div>
        <div class="college_tab margin-top">
            <div class="flex">
                <div class="content w-100 commonBackground padding-b-x  ">
                    <div   class="overview">
                        <div v-show="getDirectoryName==='专业详情'" class="main">
                            <div  class="item introduction">
                                <div style="min-height: 125px;" class="position-relative">
                                    <div  class="con" v-show="professionalDetail!==''&&!loadingDetail">
                                        <div  class="info">
                                            <div class="sonTitle font-weight-bolder text-m-size">专业简介</div>
                                            <div style="min-height: 200px;" v-show="professionalDetail.introduction!==null" class="introduction text-default-color" v-html="professionalDetail.introduction">
                                            </div>
                                            <empty content="暂无专业详情" v-show="professionalDetail.introduction===null"></empty>
                                        </div>
                                        <div class="info">
                                            <div  class="sonTitle font-weight-bolder text-m-size">从业方向</div>
                                            <div style="min-height: 200px;" v-show="professionalDetail.occupationDetail!==null" class="introduction text-default-color" v-html="professionalDetail.occupationDetail">
                                            </div>
                                            <empty content="暂无从业方向内容" v-show="professionalDetail.occupationDetail===null"></empty>
                                        </div>
                                        <div class="info">
                                            <div  class="sonTitle font-weight-bolder text-m-size">相关专业</div>
                                            <div style="min-height: 200px;" v-show="professionalDetail.occupationalDirection!==null" class="introduction text-default-color" v-html="professionalDetail.occupationalDirection">
                                            </div>
                                            <empty content="暂无相关专业内容" v-show="professionalDetail.occupationalDirection===null"></empty>
                                        </div>
                                    </div>
                                    <loading :show="loadingDetail" width="1000px"></loading>
                                </div>
                            </div>
                        </div>
                        <profession-bk-zn v-show="getDirectoryName==='报考指南'" :profession-id="professionId"></profession-bk-zn>
                        <profession-employment-fx v-show="getDirectoryName==='就业解析'" :profession-id="professionId"></profession-employment-fx>
                        <profession-speciality v-show="getDirectoryName==='专业特质'" :profession-id="professionId"></profession-speciality>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import {EventBus} from "../../../assets/static/global/event-bus";
    import professionBkZn from './components/professionBkZn'
    import professionEmploymentFx from './components/professionEmploymentFx'
    import professionSpeciality from './components/professionSpeciality'
    import {professionDetail} from "../../../config";
    export default {
        name: "professionDetail",
        components:{
          professionBkZn,
          professionEmploymentFx,
          professionSpeciality
        },
        data(){
            return{
                getDirectoryName:'专业详情',
                //获取是否收藏
                getProfessionFav:0,
                professionId:'',
                professionalDetail:'',
                loadingDetail:false,
                //左侧目录列表
                getLeftDirectoryList:[
                    {id:1,name:'专业详情'},
                    {id:2,name:'报考指南'},

                    {id:4,name:'专业特质'},
                    {id:5,name:'就业解析'},

                ],
                gudMenu:false
            }
        },
        mounted() {
            this.professionId=this.$route.query.professionId;
            this.getProfessionalOne();
            window.onscroll=(()=>{
                if(window.pageYOffset>=188){
                    this.gudMenu=true;
                }else{
                    this.gudMenu=false;
                }
            })
        },
        beforeRouteLeave(to,from,next){
          window.onscroll(()=>{
          })
            next();
        },
        methods:{
            selectDirectory(val){
                this.getDirectoryName=val;
                if(val==='报考指南'){
                    EventBus.$emit('professionBkZn');
                }else if(val==='就业解析'){
                    EventBus.$emit('professionJx',{name:this.professionalDetail.majorName});
                }else if(val==='专业特质'){
                    EventBus.$emit('zyTz');
                }else if(val==='就业走向'){
                    EventBus.$emit('jyZx')
                }

            },

            //查出专业详情
            async getProfessionalOne(){
                this.loadingDetail=true;
                let result=await professionDetail(this.professionId);
                if(result.status){
                    this.loadingDetail=false;
                    // console.log(result.data);
                    this.professionalDetail=result.data;
                    console.log(this.professionalDetail);
                    console.log('我是专业详情');
                    console.log(result);
                }else{
                    this.loadingDetail=false;
                }
            },
        }
    }
</script>
<style lang="scss">
    .info{
        .introduction{
            p{
                margin-bottom: 10px;
            }
        }
    }
</style>
<style lang="scss" scoped>
    .menuStyle.gud{
        position: fixed;
        top:70px;
        width: calc(100vw - 260px);
        z-index: 999;
        margin-right: 30px;
    }
    #collegeDetail{
        .college_info{
            padding-top:0;
            padding-bottom:0;

            .logo{
                font-weight: 400;
            }
            .titltTop{
                .right{
                    .xc{
                        margin-right: 20px;
                        font-size: 16px;
                        .salary{
                            font-size: 20px;
                        }
                    }
                }
            }
            .w-1200{
                .margin-top{
                    >div{
                        margin-right:100px;
                    }
                }
            }
        }
        .college_tab{
            .g-wrapper{  margin-top: 0;
            }
            .content{
                border: 1px solid #e1e1e1;

                .title{
                    border-left: 5px solid #0081cc;

                    background-color: #f3f3f3;
                    padding: 6px 0 6px 30px
                }
                .overview{
                    padding-bottom: 50px;
                }
            }
        }
    }
</style>
